export default __webpack_public_path__ + "static/media/PuzzlePiece.71428703.svg";